function logger (error) {
  console.log(error)
}

export default logger;
